import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 异议处理路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @returns <Object> route
 */
export default function generateObjectionRoutes(
  modulePath = 'objection',
  prefix = '',
  sideMenuTitle = '异议处理',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right]
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: 'icon-side_yiyi',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 异议列表
      {
        path: 'list/:objectionId?',
        name: `${prefix}ObjectionList`,
        component: '/procure-views/objection/index',
        type: menuTypeDict.MENU.value,
        meta: {
          title: '异议列表',
          cache: true,
          hidden: true,
          pageComponentName: 'ObjectionList'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: []
      }
    ]
  }
}
